/**
 * Video Volume Toggle Box
 **/
export const VideoVolumeToggle = function( $ ) {

	const module = {

		elements: {
			$volumeToggle: $( '.js--video-volume-toggle' ),
			heroVideo: document.querySelector( '.hero-video' ),
			$heroVideo: $( '.hero-video' ),
		},

		mute: function() {

			this.elements.$volumeToggle
				.find( '[data-fa-i2svg]' )
				.addClass( 'fa-volume-mute' )
				.removeClass( 'fa-volume-up' );

			this.elements.heroVideo.muted = true;

		},

		unmute: function() {

			this.elements.$volumeToggle
				.find( '[data-fa-i2svg]' )
				.addClass( 'fa-volume-up' )
				.removeClass( 'fa-volume-mute' );

			this.elements.heroVideo.muted = false;

		},

	};

	module.elements.$volumeToggle.click( function( e ) {
		e.preventDefault();

		const $toggle = $( this );

		if ( $toggle.hasClass( 'is-muted' ) ) {
			module.unmute();
			$toggle.removeClass( 'is-muted' );
		} else {
			module.mute();
			$toggle.addClass( 'is-muted' );
		}

	} );

	return module;

}( jQuery );
